import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

export class SiteNav extends Component {
	constructor(props){
		super(props);

		this.state = { shown: this.props.shown };

		this.toggleShown = this.toggleShown.bind(this);
	}

	toggleShown(props){
		this.setState((prevState, props) => {
			return { shown: !prevState.shown};
		});
	}

	render() {
		return (
			<div>
				<NavButton onClick={this.toggleShown} isOpen={ this.state.shown } />
				{this.state.shown && (<NavList onKeyDown={this.toggleShown} onClick={this.toggleShown}/>) }
			</div>
		)
	}
};

SiteNav.propTypes = {
	shown: PropTypes.bool
}
SiteNav.defaultProps = {
	shown: false
}

const NavButton = (props) => {
	const navButtonStyles = {
		background: 'transparent',
		border: 'none',
		cursor: 'pointer'
	};

	return (
		<button className={`nav-button hamburger hamburger--squeeze ${props.isOpen ? 'is-active' : ''}`} type="button" style={navButtonStyles} onClick={props.onClick}>
			<span className="hamburger-box">
			  <span className="hamburger-inner"></span>
			</span>
		</button>
	);
}

NavButton.propTypes = {
	isOpen: PropTypes.bool
}
NavButton.defaultProps = {
	isOpen: false
}

class NavList extends Component {
	constructor(props){
		super(props);

		this.handleKeyDown = this.handleKeyDown.bind(this);
	}

	handleKeyDown(e) {
		if( e.keyCode === 27 ){
			this.props.onKeyDown();
		}
	}

	componentDidMount() {
    window.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }

	render() {
		return (
			<ul className="site-navigation" tabIndex="0">
				<NavLi exact={true} target="/" title="Home" onClick={this.props.onKeyDown} />
				<NavLi target="/about" title="About" onClick={this.props.onKeyDown} />
				<NavLi target="/portfolio" title="Portfolio" onClick={this.props.onKeyDown} />
				<NavLi target="/contact" title="Contact" onClick={this.props.onKeyDown} />
			</ul>
		)
		// <NavLi target="/topics" title="Topics" onClick={this.props.onKeyDown} />
	}
}

export const NavLi = (props) => {
		return (
				<li className="nav-item"><NavLink exact={props.exact} to={props.target} onClick={props.onClick}>{props.title}</NavLink></li>
		)
}

NavLi.propTypes = {
	target:	PropTypes.string,
	title:	PropTypes.string,
	exact: PropTypes.bool
};

export default SiteNav;



// WEBPACK FOOTER //
// ./src/SiteNav.js